import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import type { RelatedContactFormResult } from "./AddRelatedContactForm";
import { toDateStringAnswer } from "../../utils";

export const convertRelatedContactToContact = (
  { relationship, dateOfBirth, phoneNumber, fields, ...contact }: RelatedContactFormResult,
  relatedEnduserId: string
): Partial<TellescopeModelFromName<"endusers">> => {
  return {
    ...contact,
    phone: phoneNumber,
    relationships: [{ type: relationship, id: relatedEnduserId }],
    dateOfBirth: dateOfBirth ? toDateStringAnswer(dateOfBirth) : undefined,
    ...(fields ? { fields } : {}),
  };
};
